import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 10l-6 -6l-6 6h12","key":"svg-0"}],["path",{"d":"M18 14l-6 6l-6 -6h12","key":"svg-1"}]]

/**
 * IconCaretUpDown
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2FyZXQtdXAtZG93biIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggMTBsLTYgLTZsLTYgNmgxMiIgLz4KICA8cGF0aCBkPSJNMTggMTRsLTYgNmwtNiAtNmgxMiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/caret-up-down
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCaretUpDown = createReactComponent('outline', 'caret-up-down', 'CaretUpDown', __iconNode);

export default IconCaretUpDown;